import { useEffect, useCallback, useState } from "react";

import { FilterFunction } from "types/types";

const useDropdown = ({
  filterFunctions,
}: {
  filterFunctions: Record<string, FilterFunction<any>>;
}) => {
  const [error, setError] = useState<Error>(undefined);

  const [selectedFilter, setSelectedFilter] = useState(
    Object.keys(filterFunctions)[0]
  );

  const [componentPropsList, setComponentPropsList] = useState([]);

  const fetchDataForComponent = async () => {
    try {
      const data = await filterFunctions[selectedFilter]();

      setComponentPropsList(data);
    } catch (e) {
      setError(e);
    }
  };

  const handleDropdownSelect = useCallback((option: string) => {
    setSelectedFilter(option);
  }, []);

  useEffect(() => {
    setError(undefined);
    fetchDataForComponent();
  }, [selectedFilter]);

  return {
    componentPropsList,
    selectedFilter,
    error,
    handleDropdownSelect,
  };
};

export { useDropdown };
